export default __webpack_public_path__ + "static/media/10.a7d7e158.jpeg";